"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sv = require("./sv");

var _sv2 = _interopRequireDefault(_sv);

var _en = require("./en");

var _en2 = _interopRequireDefault(_en);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  en: _en2.default,
  sv: _sv2.default
};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/translations/translations.js
// module id = La0l
// module chunks = 0 1